import React from 'react';
import { StickableTanstackTable } from 'components/common/Table/StickableTanstackTable';
import { CreditListColumns, useCreditListModel } from './CreditListModel';
import i18n from 'i18n';
import styles from './creditList.module.scss';
import { SearchBar } from 'components/common/SearchBar';
import { LoadingIndicator } from 'components/common/LoadingIndicator';

export type CreditListProps = Record<string, never>;

export const CreditList: React.FC<CreditListProps> = () => {
  const { state, columns, loading, onHandleSearch } = useCreditListModel();

  return (
    <div className={styles.creditList}>
      {loading && <LoadingIndicator />}
      <div className={styles.titleArea}>
        <div className={styles.title}>{i18n.t('creditList.labels.title')}</div>
      </div>
      <div className={styles.filterArea}>
        <SearchBar
          model={{
            placeholder: i18n.t('creditList.placeholders.searchbar'),
            search: onHandleSearch,
            defaultValue: state.searchString
          }}
        />
      </div>
      <div className={styles.contentArea}>
        <StickableTanstackTable
          stickFirstColumn
          stickLastColumn
          keyField={CreditListColumns.ID}
          data={state.filteredList}
          columns={columns}
          noDataIndication={i18n.t('creditList.labels.noData')}
          defaultSorted={[
            {
              dataField: CreditListColumns.ID,
              order: 'desc'
            }
          ]}
        />
      </div>
    </div>
  );
};
